import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const partnerTextSchema = new schema.Entity('partnerText');

export const partnerText = configureApiEntity('PARTNER_TEXT', 'partnertext', partnerTextSchema);
